import React, { useMemo } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import { _T } from 'appI18n';
import HorizontalList from 'react-components/HorizontalList';
import Rating from 'react-components/Rating';
import { formatMoney } from 'utils';
import { useTourDescription, useTourDescriptionStore, useTourExtras, useTourVariant } from '../../../store/TourDescriptionStore';
import { tourDetailsUrlRR } from '../../../tour-urlgen';
import Carousel from 'react-components/Carousel';
const useStyles = makeStyles((theme) => ({
    root: {},
    card: {
        width: 200,
        minWidth: 200,
    },
    cardRoot: {
        position: 'relative',
    },
    cardWrapper: {
        padding: '3px 6px'
    },
    media: {
        height: 150,
        maxHeight: 150,
        position: 'relative',
    },
    skeleton: {
        height: 348,
        width: 200,
    },
    description: {
        lineClamp: 2,
        overflow: 'hidden',
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        minHeight: '3em',
    },
    ribbon: {
        top: 12,
        left: -4,
        padding: '4px 8px',
        position: 'absolute',
        background: '#ffc800',
        color: '#674c1a',
        textTransform: 'uppercase',
        fontSize: '0.85rem',
        fontWeight: 600,
        letterSpacing: -0.5,
        boxShadow: '2px 2px 2px rgb(0 0 0 / 25%)',
        '&:before': {
            borderTop: '4px solid #695a27',
            borderLeft: '4px solid transparent',
            content: "' '",
            display: 'block',
            position: 'absolute',
            left: 0,
            bottom: -4,
        },
    },
    fullWidth: { width: '100%' },
    cursorDefault: { cursor: 'default' },
}), { name: 'HotelRecommendations' });
function HotelRecommendation({ recommendation, isFrame }) {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const [{ currentAccommodationVariants }] = useTourVariant(isFrame);
    //const [{ tourDescription: { id: tourId, name: tourName, currency }, excursionServices }] = useTourDescription(null, isFrame);
    const [{ tourDescription: { id: tourId, name: tourName, currency }, externalFlight, externalFlightId, externalFlightProviderId }, actions] = useTourDescription(null, isFrame);
    const [{ tourServices, search }] = useTourDescriptionStore(isFrame);
    const [{ extras }] = useTourExtras(isFrame);
    const hotelServices = useMemo(() => tourServices === null || tourServices === void 0 ? void 0 : tourServices.filter(s => s.type == "hotel").map(s => s), [tourServices]);
    const excursionServices = useMemo(() => tourServices === null || tourServices === void 0 ? void 0 : tourServices.filter(s => s.type == "excursion").map(s => s), [tourServices]);
    const excursionServicesString = useMemo(() => (excursionServices === null || excursionServices === void 0 ? void 0 : excursionServices.length) > 0 ? excursionServices.map(e => `${e.id}__${e.beginDate}=${(e.currentVehicleTypeId == undefined ? '' : e.currentVehicleTypeId)}`).reduce((pr, curr) => `${pr};${curr}`) : "", [excursionServices]);
    const params = useParams();
    const descs = recommendation.hotelDescriptions;
    const tourUrl = useMemo(() => {
        return tourDetailsUrlRR(tourId, {
            tourName: tourName,
            //accmmdId: recommendation.accmmdVariantIdForBestPrice,
            //variantId: recommendation.tourVariantIdForBestPrice,
            state: location.state,
            excursions: excursionServices === null || excursionServices === void 0 ? void 0 : excursionServices.map(s => ({ id: s.id, vehicleTypeId: s.currentVehicleTypeId })),
            hash: recommendation.bestPriceHash,
            externalFlight: externalFlight !== null && externalFlight !== void 0 ? externalFlight : (externalFlightId && externalFlightProviderId ? { flightId: externalFlightId, providerId: externalFlightProviderId } : undefined),
            extras: extras,
            search: search,
        }, params['frameId']);
    }, [tourName, tourId, location.state, excursionServicesString, params['frameId'], recommendation.bestPriceHash, externalFlight, externalFlightId, externalFlightProviderId]);
    //}, [tourName, tourId, recommendation.tourVariantIdForBestPrice, recommendation.accmmdVariantIdForBestPrice, location.state, excursionServicesString, params['frameId'], recommendation.bestPriceHash]);
    //const isCurrentHotel = useMemo(() => hotelServices.map(h => `${h.hotelDescription.hotelId}`).reduce((a, b) => a ? `${a} | ${b}` : a, '') == recommendation.hotelDescriptions.map(h => `${h.hotelId}`).reduce((a, b) => a ? `${a} | ${b}` : a, ''), [hotelServices, recommendation]);
    const isCurrentHotel = useMemo(() => currentAccommodationVariants.map(h => `${h.hotelDescription.hotelId}`).reduce((a, b) => a ? `${a} | ${b}` : b, '') == recommendation.hotelDescriptions.map(h => `${h.hotelId}`).reduce((a, b) => a ? `${a} | ${b}` : b, ''), [currentAccommodationVariants, recommendation]);
    //currentAccommodationVariant?.accommodation?.hotelId == recommendation.hotelDescription.hotelId;
    // TODO: сделать враппер для ссылки который позволяет ее отключить булевым атрибутом.
    const handleLinkClicked = (e) => isCurrentHotel ? e.preventDefault() : void (0);
    return React.createElement("div", { className: classes.cardWrapper },
        React.createElement("div", { className: classes.cardRoot },
            React.createElement(Card, { className: classes.card },
                React.createElement(CardActionArea, { disabled: isCurrentHotel }, (() => {
                    var _a;
                    const distinctDesc = descs.filter((v, i, a) => a.findIndex(h => h.hotelId == v.hotelId) == i);
                    if (distinctDesc.length == 1) {
                        const desc = distinctDesc[0];
                        return React.createElement(React.Fragment, null,
                            React.createElement(CardMedia, { className: classes.media, image: (_a = desc.mainImage) === null || _a === void 0 ? void 0 : _a.urls.thumbnail, title: desc.hotelName, onClick: () => {
                                    if (isCurrentHotel)
                                        return;
                                    //history.replace(tourUrl);
                                    actions.setPriceItem(recommendation.bestPriceHash);
                                } }),
                            React.createElement(CardContent, null,
                                React.createElement(Typography, { gutterBottom: true, variant: "h5", color: "primary", component: "h2", noWrap: true },
                                    desc.hotelName,
                                    desc.starRating && React.createElement("div", null,
                                        React.createElement(Rating, { rating: desc.starRating })) || null),
                                React.createElement(Typography, { variant: "body2", color: "textSecondary", component: "p", className: classes.description, gutterBottom: true }, desc.description),
                                React.createElement(Typography, { variant: "subtitle1", color: "secondary", component: "p" },
                                    _T.COMMON_FROM,
                                    " ",
                                    React.createElement(Typography, { variant: "h6", component: "span", style: { paddingLeft: '2px' } },
                                        formatMoney(recommendation.bestPrice, { currency: currency.name }),
                                        " ",
                                        currency.name))));
                    }
                    else {
                        return React.createElement(React.Fragment, null,
                            React.createElement(Carousel, { autoPlay: true, animation: "slide", fullHeightHover: true, navButtonsAlwaysVisible: !isCurrentHotel }, distinctDesc.map(desc => {
                                var _a;
                                return (React.createElement(React.Fragment, null,
                                    React.createElement(CardMedia, { className: classes.media, image: (_a = desc.mainImage) === null || _a === void 0 ? void 0 : _a.urls.thumbnail, title: desc.hotelName, onClick: () => {
                                            if (isCurrentHotel)
                                                return;
                                            //history.replace(tourUrl);
                                            actions.setPriceItem(recommendation.bestPriceHash);
                                        } }),
                                    React.createElement(CardContent, { style: { paddingBottom: 0 } },
                                        React.createElement(Typography, { gutterBottom: true, variant: "h5", color: "primary", component: "h2", noWrap: true },
                                            desc.hotelName,
                                            desc.starRating && React.createElement("div", null,
                                                React.createElement(Rating, { rating: desc.starRating })) || null),
                                        React.createElement(Typography, { variant: "body2", color: "textSecondary", component: "p", className: classes.description, gutterBottom: true }, desc.description))));
                            })),
                            React.createElement(CardContent, { style: { paddingTop: 0 } },
                                React.createElement(Typography, { variant: "subtitle1", color: "secondary", component: "p" },
                                    _T.COMMON_FROM,
                                    " ",
                                    React.createElement(Typography, { variant: "h6", component: "span", style: { paddingLeft: '2px' } },
                                        formatMoney(recommendation.bestPrice, { currency: currency.name }),
                                        " ",
                                        currency.name))));
                    }
                })()),
                React.createElement(CardActions, null,
                    React.createElement(Button, { color: "primary", variant: "outlined", fullWidth: true, size: "small", disabled: isCurrentHotel, onClick: () => {
                            //history.replace(tourUrl);
                            return actions.setPriceItem(recommendation.bestPriceHash);
                        } }, !isCurrentHotel ? _T.COMMON_VIEW : _T.TOUR_CURRENTLY_VIEWED_HOTEL))),
            isCurrentHotel ? React.createElement("div", { className: classes.ribbon }, _T.COMMON_CURRENTLY_VIEWED) : null));
}
export default function HotelRecommendations(props) {
    const classes = useStyles();
    return React.createElement("div", { className: classes.root }, (() => {
        if (props.loading) {
            return React.createElement(Box, { display: "flex" }, [1, 2, 3].map(x => React.createElement(Box, { key: x, mr: 1.5 },
                React.createElement(Skeleton, { variant: "rect", className: classes.skeleton }))));
        }
        const items = props.recommendations.sort((a, b) => a.bestPrice - b.bestPrice).map((x, i) => React.createElement(HotelRecommendation, { recommendation: x, key: i, isFrame: props.isFrame, hash: props.hash }));
        return items.length > 1 ? React.createElement(HorizontalList, null, items) : null;
    })());
}
